var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('img',{staticClass:"header__logo",attrs:{"alt":"logo","src":_vm.logo}}),_c('button',{staticClass:"header__button",on:{"click":_vm.logout}},[_vm._v("Cerrar Sesión")])])
}
var staticRenderFns = []

export { render, staticRenderFns }